// src/components/SoilIndicator.js
import React from "react";
import { Tooltip } from "@mui/material";

const SoilIndicator = ({ indicator }) => {
  const config = {
    improves: { 
      icon: "↑", 
      color: "#4caf50", 
      label: "Improves soil health" 
    },
    neutral: { 
      icon: "→", 
      color: "#ff9800", 
      label: "Neutral soil impact" 
    },
    depletes: { 
      icon: "↓", 
      color: "#f44336", 
      label: "Depletes soil nutrients" 
    }
  };
  
  const { icon, color, label } = config[indicator] || config.neutral;
  
  return (
    <Tooltip title={label}>
      <span 
        style={{ 
          color, 
          fontWeight: 'bold', 
          fontSize: '16px',
          cursor: 'help'
        }}
      >
        {icon}
      </span>
    </Tooltip>
  );
};

export default SoilIndicator;
